import {
  Box,
  ColumnLayout,
  Input,
  SpaceBetween,
  FormField,
} from "@cloudscape-design/components-themed";
import {
  LABELS,
  getBusinessStyleLabel,
  getExaminationComprehensiveStatusLabel,
} from "./constants";
import { formatDate } from "../../utils/format";

interface IExaminationInfo {
  examinationApplicationNo: string;
  applicationNo: number;
  applicationDate: string;
  applicationManager: string;
  applicationType: string;
  examinationType: string;
  isStore: boolean;
  registerName: string;
  companyName: string;
  businessStyle: string;
  corporateNumber: string;
  merchantName: string;
  examinationComprehensiveStatus: number;
  approvalStatus: number;
}

/**
 * 申請情報
 */
const ExaminationInfo = (props: IExaminationInfo) => {
  const {
    examinationApplicationNo,
    applicationNo,
    applicationDate,
    applicationManager,
    applicationType,
    examinationType,
    isStore,
    registerName,
    companyName,
    businessStyle,
    corporateNumber,
    merchantName,
    examinationComprehensiveStatus,
  } = props;

  return (
    <SpaceBetween direction={"vertical"} size={"l"}>
      <Box margin={"s"}>
        <ColumnLayout columns={4}>
          <FormField label={LABELS.EXAMINATION_APPLICATION_NO}>
            <Input value={examinationApplicationNo} readOnly />
          </FormField>
          <FormField label={LABELS.APPLICATION_NO}>
            <Input
              value={applicationNo === -1 ? "" : String(applicationNo)}
              readOnly
            />
          </FormField>
          <FormField label={LABELS.APPLICATION_DATE}>
            <Input value={formatDate(applicationDate)} readOnly />
          </FormField>
          <FormField label={LABELS.APPLICATION_MANAGER}>
            <Input value={applicationManager} readOnly />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={4}>
          <FormField label={LABELS.APPLICATION_TYPE}>
            <Input value={applicationType} readOnly />
          </FormField>
          <FormField label={LABELS.EXAMINATION_TYPE}>
            <Input value={examinationType} readOnly />
          </FormField>
        </ColumnLayout>
        {isStore && (
          <ColumnLayout columns={1}>
            <FormField label={LABELS.REGISTER_NAME}>
              <Input value={registerName} readOnly />
            </FormField>
          </ColumnLayout>
        )}
        <ColumnLayout columns={1}>
          <FormField label={LABELS.COMPANY_NAME}>
            <Input value={companyName} readOnly />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={1}>
          <FormField label={LABELS.BUSINESS_STYLE}>
            <Input value={getBusinessStyleLabel(businessStyle)} readOnly />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={8}>
          <FormField label={LABELS.CORPORATE_NUMBER}>
            <Input value={corporateNumber} readOnly />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={1}>
          <FormField label={LABELS.MERCHANT_NAME}>
            <Input value={merchantName} readOnly />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={1}>
          <FormField label={LABELS.EXAMINATION_COMPREHENSIVE_STATUS}>
            <Input
              value={getExaminationComprehensiveStatusLabel(
                examinationComprehensiveStatus
              )}
              readOnly
            />
          </FormField>
        </ColumnLayout>
      </Box>
    </SpaceBetween>
  );
};

export default ExaminationInfo;
